<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useCompaniesStore } from 'dashboard/stores/companies';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import TwoColumnDetailLayout from 'dashboard/components-next/TwoColumnDetailLayout.vue';
import CompanyDetailSidebar from 'dashboard/components-next/Companies/CompanyDetail/CompanyDetailSidebar.vue';
import InPlaceConversationPanel from 'dashboard/components-next/Conversation/InPlaceConversationPanel.vue';
import LinkedEntityPane from 'dashboard/components-next/LinkedEntityPane.vue';
import TimelineChat from 'dashboard/components-next/Timeline/TimelineChat.vue';

const route = useRoute();
const router = useRouter();
const companiesStore = useCompaniesStore();

const companyId = computed(() => Number(route.params.companyId));
const company = computed(() => companiesStore.getCompanyById(companyId.value));
const isFetching = computed(() => companiesStore.uiFlags.fetchingItem);

onMounted(() => {
  companiesStore.show(companyId.value);
});

// Conversa aberta no painel da direita (no lugar do Historico)
const activeConversationId = ref(null);

const goBack = () => {
  if (activeConversationId.value) {
    activeConversationId.value = null;
    return;
  }
  if (window.history.state?.back) {
    router.back();
    return;
  }
  router.push({
    name: 'companies_dashboard_index',
    params: { accountId: route.params.accountId },
  });
};

// --- Historico recarrega sozinho quando algo da empresa muda na coluna esquerda ---
const timelineChatRef = ref(null);
const handleCompanyUpdated = () => {
  timelineChatRef.value?.refetch();
};
const handleLinkedUpdated = handleCompanyUpdated;
</script>

<template>
  <TwoColumnDetailLayout
    :is-loading="isFetching"
    :has-data="!!company?.id"
    :storage-key="LOCAL_STORAGE_KEYS.COMPANY_DETAIL_SIDEBAR_WIDTH"
  >
    <template #sidebar>
      <LinkedEntityPane
        :key="company.id"
        :active-conversation-id="activeConversationId"
        @open-conversation="id => (activeConversationId = id)"
        @close-conversation="activeConversationId = null"
        @linked-updated="handleLinkedUpdated"
      >
        <CompanyDetailSidebar
          :company="company"
          @back="goBack"
          @updated="handleCompanyUpdated"
        />
      </LinkedEntityPane>
    </template>
    <template #timeline>
      <InPlaceConversationPanel
        v-if="activeConversationId"
        :conversation-id="activeConversationId"
      />
      <TimelineChat
        v-else
        ref="timelineChatRef"
        subject-type="Company"
        :subject-id="company.id"
      />
    </template>
  </TwoColumnDetailLayout>
</template>
